import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';

import { Icon } from './Icon';

export interface ChipProps extends MuiChipProps {
  active?: boolean;
  variant?: 'soft' | 'outlined' | 'filled';
}

export function Chip<C extends React.ElementType = 'button'>(
  props: MuiChipProps<C, { component?: C } & ChipProps>
) {
  const {
    color = 'secondary',
    clickable,
    sx,
    variant = 'soft',
    active = false,
    ...otherProps
  } = props;

  const internalColor = active ? 'primary' : color;
  const internalVariant = active ? 'soft' : variant;

  const styles = [
    internalVariant === 'outlined' && {
      borderColor: `${color}.borderStrong`,
      color: `${color}.text`,
    },
    {
      '& .MuiChip-deleteIcon': {
        fontSize: '16px',
        color:
          internalVariant === 'filled'
            ? `${color}.contrastText`
            : 'action.active',
      },
    },
    {
      '&. MuiChip-label': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      '& .MuiChip-icon': {
        marginLeft: '5px',
      },
    },
  ];

  return (
    <MuiChip
      sx={[...styles, ...(Array.isArray(sx) ? sx : [sx])]}
      variant={internalVariant}
      color={internalColor}
      clickable={clickable}
      deleteIcon={<Icon icon={faTimes} />}
      {...otherProps}
    ></MuiChip>
  );
}
